import React from 'react';
import {
    EMAIL_MANAGEMENT_TYPE,
    EMAIL_MANAGEMENT_TYPE_OPTIONS,
} from '../../constants/emailManagementForm';

const EmailManagementTypeTabs = ({
    value = EMAIL_MANAGEMENT_TYPE.STANDARD,
    onChange,
    disabled = false,
}) => (
    <div className="aee-type-tabs-block">
        <h2 className="aee-type-tabs-title">Type de gestion des e-mails</h2>
        <div
            className="aee-type-tabs"
            role="tablist"
            aria-label="Type de gestion des e-mails"
        >
        {EMAIL_MANAGEMENT_TYPE_OPTIONS.map((opt) => {
            const isActive = value === opt.value;
            return (
                <button
                    key={opt.value}
                    type="button"
                    role="tab"
                    className={`aee-type-tab${isActive ? ' is-active' : ''}`}
                    aria-selected={isActive}
                    aria-controls={`aee-form-panel-${opt.value}`}
                    id={`aee-type-tab-${opt.value}`}
                    disabled={disabled}
                    onClick={() => {
                        if (!disabled && value !== opt.value) onChange(opt.value);
                    }}
                >
                    {opt.label}
                </button>
            );
        })}
        </div>
    </div>
);

export default EmailManagementTypeTabs;
